import React, { useState } from 'react';
import { X, Smile, ThumbsUp, Heart, Zap, Trophy, BoxIcon } from 'lucide-react';
import { cn } from '../../lib/utils';
interface ChatPanelProps {
  isOpen: boolean;
  onClose: () => void;
  onSendEmote: (emote: string) => void;
}
const EMOTES = [{
  icon: ThumbsUp,
  label: 'Nice!',
  color: 'text-blue-500'
}, {
  icon: BoxIcon,
  label: 'On fire!',
  color: 'text-orange-500'
}, {
  icon: Heart,
  label: 'Love it!',
  color: 'text-red-500'
}, {
  icon: Zap,
  label: 'Quick!',
  color: 'text-yellow-500'
}, {
  icon: Trophy,
  label: 'Winner!',
  color: 'text-amber-500'
}, {
  icon: Smile,
  label: 'GG!',
  color: 'text-emerald-500'
}];
export function ChatPanel({
  isOpen,
  onClose,
  onSendEmote
}: ChatPanelProps) {
  if (!isOpen) return null;
  return <>
      <div className="fixed inset-0 bg-black/30 z-40 animate-in fade-in duration-200" onClick={onClose} data-id="element-83" />
      <div className="fixed bottom-0 left-0 right-0 bg-white rounded-t-3xl shadow-2xl z-50 animate-in slide-in-from-bottom duration-300 max-w-md mx-auto" data-id="element-84">
        <div className="flex items-center justify-between p-4 border-b border-slate-200" data-id="element-85">
          <h3 className="font-bold text-slate-900" data-id="element-86">Quick Reactions</h3>
          <button onClick={onClose} className="p-2 -mr-2 text-slate-400 hover:bg-slate-100 rounded-full" data-id="element-87">
            <X size={20} data-id="element-88" />
          </button>
        </div>

        <div className="p-4 grid grid-cols-3 gap-3" data-id="element-89">
          {EMOTES.map(emote => {
          const Icon = emote.icon;
          return <button key={emote.label} onClick={() => {
            onSendEmote(emote.label);
            onClose();
          }} className="flex flex-col items-center gap-2 p-4 rounded-xl hover:bg-slate-50 active:scale-95 transition-all" data-id="element-90">
                <div className={cn('p-3 rounded-full bg-slate-100', emote.color)} data-id="element-91">
                  <Icon size={24} data-id="element-92" />
                </div>
                <span className="text-xs font-semibold text-slate-600" data-id="element-93">
                  {emote.label}
                </span>
              </button>;
        })}
        </div>
      </div>
    </>;
}